import { useDebouncedEffect } from '@react-hookz/web';
import { type FC, useEffect, useState } from 'react';

import Icon from 'molecules/Icon';

import { setConnectorsSearch, useConnectorsSearch } from 'layout/Listing/variants/connectors/store';

const SearchBar: FC = () => {
  const searchStore = useConnectorsSearch();
  const [search, setSearch] = useState('');

  useDebouncedEffect(() => setConnectorsSearch(search), [search], 500);

  useEffect(() => {
    setSearch(searchStore);
  }, [searchStore]);

  return (
    <div className="flex w-full max-w-[376px] items-center gap-1.5 rounded-md border-[1.5px] border-primary-200 bg-primary-50 p-2 focus-within:stateful-outline-tealCustom">
      <input
        placeholder="Search"
        onChange={e => setSearch(e.target.value)}
        value={search}
        className="w-full bg-transparent font-spaceGrotesk text-sm text-gray-900 outline-none placeholder:text-gray-900"
      />
      <div className="flex size-9 items-center justify-center rounded-md bg-primary-300">
        <Icon icon="search" size={14} />
      </div>
    </div>
  );
};

export default SearchBar;
